module.exports = __webpack_public_path__ + "no_mine.7912779a26403c9094a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/minesweeper/components/assets/no_mine.png
// module id = 189
// module chunks = 1